import React, { useLayoutEffect, useEffect, useState, useRef, useContext} from "react";
import store from "@/redux/store";
import {storeCalenderSettings, setSelectedDate, getTasks, setSelectedUsers} from '@/reducers/CommunicationCycle';

import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react'
import { Switch,Label, Field } from '@headlessui/react'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'
import { TrashIcon,ClockIcon, CogIcon, UserGroupIcon } from '@heroicons/react/16/solid'

import {TaskUser} from "@/models/TaskUsers";

interface ComponentState {
   item: TaskUser,
   rowStartTask:number
}

class PlanViewGroup extends React.Component<any, ComponentState> {
    private startCol = 2;
    private endCol = 28;
    constructor(props:any) {
        super(props);
//        let startCol = 2;
//        let endCol = 28;
    }


    render() {
        return (
            <>
            <div className={"sticky z-50 w-72 left-0 col-start-1 row-start-"+this.props?.rowStartTask+" border-r border-gray-100 bg-white p-1.5 text-left text-xs font-medium text-gray-400 uppercase dark:border-gray-200/5 dark:bg-gray-800 grid grid-cols-7 gap-1"}>
            <span className="col-span-1">
            <button type="button" 
            //onClick={(event) => {setSelectedTaskEventHandler(event, item)}}
            className="inline-flex items-center gap-x-1 rounded-md bg-indigo-600 px-1.5 py-1.5 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"><UserGroupIcon aria-hidden="true" className="size-5" /></button>
            </span>
            <span className="col-span-4 inline-flex items-center">
            {this.props?.item?.name}
            </span>
            <span className="col-end-7 align-center items-center justify-items-center text-center"><ClockIcon className="size-4 w-full flex" /><span className="duration" data-duration={this.props?.item?.key}>{this.props?.item?.duration}</span></span>  
            </div>
            
        <div className={"p-1 row-start-"+this.props.rowStartTask+" sticky z-30  overflow-hidden "} style={{gridColumnStart: this.startCol, gridColumnEnd: this.endCol}}>
            <div className="rounded-lg border border-blue-700/10 bg-blue-400/20 px-1 dark:border-sky-500 dark:bg-sky-600/50 overflow-hidden ">
            <span className="truncate pr5 block width-inherit text-sm text-sm/6 h-[80%]">
                {this.props?.item?.name}
            </span>
            </div>
            </div>
                  </>      
        )
        }
}

export default PlanViewGroup;